'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.connect = connect;

var _immutable = require('immutable');

var _reactRedux = require('react-redux');

var _constants = require('./constants');

var _utils = require('./utils');

var _models = require('./models');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Reasonable defaults for connecting
 */
var DEFAULT_CONNECT_DISPATCH_KEY = '_connectDispatch';
var DEFAULT_SUBSCRIPTIONS_PROPS_KEY = '_subscriptions';
var DEFAULT_MAP_API_TO_PROPS_PROPS_KEY = '_mapApiToProps';
var DEFAULT_MAP_API_TO_PROPS_META_KEY = '_mapApiToPropsMeta';

/*
 * Special sentinel for limiting to 1 and returning an item when querying a collection
 */
var LIMIT_ITEM = 'item';

var EMPTY_ACTION = { type: 'no-action' };

var NO_ACTION = function NO_ACTION() {
  return EMPTY_ACTION;
};

/*
 * Higher Order Component generator based off of this reducer that subscribes a component to a given set of data sources
 * while also wiring in the .read( ... ) calls from this reducer.
 *
 * Usage (as a decorator of a React PureComponent):
 *
 *   let api = new Api('api', ... );
 *
 *   @connect(api, {
 *     classics: 'classics',
 *     listeners: { dataSource: 'listeners', filter: 'port:5001' },
 *     housekeepers: { dataSource: 'housekeepers', filter: 'id:1', group: "group=123&agg=count" }
 *   })
 *   class MyComponent extends PureComponent {
 *     ...
 *   }
 *
 */
function connect(reducer, mapApiToProps) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$apiToPropsKe = options.apiToPropsKey,
      apiToPropsKey = _options$apiToPropsKe === undefined ? DEFAULT_MAP_API_TO_PROPS_PROPS_KEY : _options$apiToPropsKe,
      _options$apiToPropsMe = options.apiToPropsMetaKey,
      apiToPropsMetaKey = _options$apiToPropsMe === undefined ? DEFAULT_MAP_API_TO_PROPS_META_KEY : _options$apiToPropsMe,
      _options$metaPostfix = options.metaPostfix,
      metaPostfix = _options$metaPostfix === undefined ? _constants.DEFAULT_CONNECT_META_POSTFIX : _options$metaPostfix,
      _options$subscription = options.subscriptionsKey,
      subscriptionsKey = _options$subscription === undefined ? DEFAULT_SUBSCRIPTIONS_PROPS_KEY : _options$subscription,
      _options$connectDispa = options.connectDispatchKey,
      connectDispatchKey = _options$connectDispa === undefined ? DEFAULT_CONNECT_DISPATCH_KEY : _options$connectDispa,
      _options$transformPro = options.transformProps,
      transformProps = _options$transformPro === undefined ? undefined : _options$transformPro,
      _options$bundleProp = options.bundleProp,
      bundleProp = _options$bundleProp === undefined ? undefined : _options$bundleProp,
      _options$bundleMetaPr = options.bundleMetaProp,
      bundleMetaProp = _options$bundleMetaPr === undefined ? undefined : _options$bundleMetaPr;


  return function _connect(Component) {
    // Subscribe the component (if that was provided in the options to this reducer)
    if (reducer.connectSubscriber !== undefined) {
      Component = reducer.connectSubscriber(subscriptionsKey, { notifyCb: reducer.notifier })(Component);
    }

    var cache = {}; // HOC scoped cache

    //noinspection UnnecessaryLocalVariableJS
    var ConnectedComponent = (0, _reactRedux.connect)(connectMapStateToProps(reducer, mapApiToProps, apiToPropsKey, apiToPropsMetaKey, metaPostfix, subscriptionsKey), connectMapDispatchToProps(connectDispatchKey), connectMergeProps(reducer, apiToPropsKey, apiToPropsMetaKey, connectDispatchKey, metaPostfix, { transformProps: transformProps,
      bundleProp: bundleProp,
      bundleMetaProp: bundleMetaProp,
      cache: cache
    }), {
      methodName: 'apiConnect',
      getDisplayName: function getDisplayName(name) {
        return 'APIConnect(' + name + ')';
      }
    })(Component);

    return ConnectedComponent;
  };
}

/*
 * Internal model used for passing around defintions specified by user.
 */
var _ConnectDefinitionRecord = (0, _immutable.Record)({
  enabled: undefined,
  subscribed: undefined,
  dataSource: undefined,
  requires: undefined,
  dynamicDefinition: undefined,
  alias: undefined,
  query: undefined,
  sort: undefined,
  only: undefined,
  limit: undefined,
  group: undefined,
  withMeta: undefined
});

/*
 * Given a single definition line from connect's mapApiToProps, determine the dataSource, filter name and optional
 * properties.
 */
function connectExtractDefinition(definition, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$checkDataSou = options.checkDataSource,
      checkDataSource = _options$checkDataSou === undefined ? true : _options$checkDataSou,
      _options$setDefaultAl = options.setDefaultAlias,
      setDefaultAlias = _options$setDefaultAl === undefined ? true : _options$setDefaultAl;


  var enabled = void 0,
      subscribed = void 0,
      dataSource = void 0,
      requires = void 0,
      dynamicDefinition = void 0,
      group = void 0,
      query = void 0,
      sort = void 0,
      only = void 0,
      limit = void 0,
      alias = void 0,
      withMeta = void 0;

  if (definition === undefined || typeof definition === 'string') {
    // Static definition *is* the dataSource.  Just use that for simple cases
    dataSource = definition;
    group = (0, _constants.groupName)(undefined);
    alias = (0, _constants.filterDefault)();
    withMeta = false;
  } else {
    // Opting in to the more complex 'object' style static definition.
    enabled = definition.enabled;
    subscribed = !!(definition.subscribed === undefined || definition.subscribed);
    dataSource = definition.dataSource;
    requires = definition.requires;
    dynamicDefinition = definition.definition;
    group = (0, _constants.groupName)(definition.group);
    query = definition.filter;
    sort = definition.sort;
    only = definition.only;
    limit = definition.limit;
    if (setDefaultAlias) {
      alias = (0, _constants.filterDefault)(definition.alias, query, sort, only, limit);
    } else {
      alias = definition.alias;
    }
    if (definition['withMeta'] === true) {
      withMeta = definition.withMeta;
    } else {
      withMeta = false;
    }
  }

  // Check dynamic property overrides
  if (definition.enabledProp !== undefined) {
    var enableOverride = props[definition.enabledProp];
    if (enableOverride !== undefined) {
      enabled = enableOverride;
    }
  }

  if (definition.subscribedProp !== undefined) {
    var subscribedOverride = props[definition.subscribedProp];
    if (subscribedOverride !== undefined) {
      subscribed = subscribedOverride;
    }
  }

  if (definition.dataSourceProp !== undefined) {
    var dataSourceOverride = props[definition.dataSourceProp];
    if (dataSourceOverride !== undefined) {
      dataSource = dataSourceOverride;
    }
  }

  if (definition.requiresProp !== undefined) {
    var requiresOverride = props[definition.requiresProp];
    if (requiresOverride !== undefined) {
      requires = requiresOverride;
    }
  }

  if (definition.definitionProp !== undefined) {
    var definitionOverride = props[definition.definitionProp];
    if (definitionOverride !== undefined) {
      dynamicDefinition = definitionOverride;
    }
  }

  if (definition.filterProp !== undefined) {
    var filterQueryOverride = props[definition.filterProp];
    if (filterQueryOverride !== undefined) {
      query = filterQueryOverride;
    }
  }

  if (definition.sortProp !== undefined) {
    if (definition.alias === undefined) {
      throw 'Unable to use dynamic sort without a fixed alias: ' + definition + '.';
    }

    var sortOverride = props[definition.sortProp];
    if (sortOverride !== undefined) {
      sort = sortOverride;
    }
  }

  if (definition.onlyProp !== undefined) {
    if (definition.alias === undefined) {
      throw 'Unable to use dynamic only without a fixed alias: ' + definition + '.';
    }

    var onlyOverride = props[definition.onlyProp];
    if (onlyOverride !== undefined) {
      only = onlyOverride;
    }
  }

  if (definition.limitProp !== undefined) {
    if (definition.alias === undefined) {
      throw 'Unable to use dynamic limit without a fixed alias: ' + definition + '.';
    }

    var limitOverride = props[definition.limitProp];
    if (limitOverride !== undefined) {
      limit = limitOverride;
    }
  }

  if (definition.aliasProp !== undefined) {
    var filterNameOverride = props[definition.aliasProp];
    if (filterNameOverride !== undefined) {
      alias = filterNameOverride;
    }
  }

  if (definition.groupProp !== undefined) {
    var groupOverride = props[definition.groupProp];
    if (groupOverride !== undefined) {
      group = groupOverride;
    }
  }

  // SPECIAL: withMeta override behaves a little differently.  If the static definition requests withMeta then the
  //          dynamic override cannot undo that, however the dynamic can "upgrade" to withMeta if the static
  //          definition did not request it.
  if (definition.withMetaProp !== undefined) {
    var withMetaOverride = props[definition.withMetaProp];
    withMeta = withMeta === true || withMetaOverride === true;
  }

  if (checkDataSource && dataSource === undefined) {
    throw 'Unable to connect a dataSource that was not declared in the definition: ' + definition + '.';
  }

  return _ConnectDefinitionRecord({
    enabled: enabled,
    subscribed: subscribed,
    dataSource: dataSource,
    requires: requires,
    dynamicDefinition: dynamicDefinition,
    alias: alias,
    query: query,
    sort: sort,
    only: only,
    limit: limit,
    group: group,
    withMeta: withMeta
  });
}

/*
 * CONNECT EXTRACT DEPENDENCIES
 *
 * Examine the API to props map to extract all dependency information
 */
function connectExtractDependencies(mapApiToPropsMap, ownProps) {
  var definitions = {};
  var dependencies = [];

  // Format props and definition into a topologicalList compatible array
  var topList = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _utils.walkMap)(mapApiToPropsMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          prop = _step$value[0],
          userDefinition = _step$value[1];

      var definition = connectExtractDefinition(userDefinition, ownProps);
      topList.push({ prop: prop, definition: definition });
      definitions[prop] = definition;

      if (definition.requires !== undefined) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = definition.requires[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var required = _step2.value;

            dependencies.push(required);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }

    // Settify all props that have depdencies for quick lookup of meta
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  dependencies = (0, _immutable.Set)(dependencies);

  // Sort props topologically (process props in dependency-sensitive order)
  var topSorted = (0, _utils.topologicalList)(topList, function (i) {
    return i.prop;
  }, function (i) {
    return i.definition.requires ? i.definition.requires : [];
  });

  // topologicalList returns an array of arrays.  Flatten into a single contiguous array.
  var propOrder = [].concat.apply([], topSorted);

  return { propOrder: propOrder, definitions: definitions, dependencies: dependencies };
}

/*
 * Generate a React-Redux connect compatible mapStateToProps function based on a set of data sources
 */
function connectMapStateToProps(reducer, mapApiToProps, apiToPropsKey, apiToPropsMetaKey, metaPostfix, subscriptionsKey) {
  return function _connectMapStateToProps(state, ownProps) {
    var stateToProps = {};
    var mapApiToPropsMap = mapApiToProps;

    // Check if `mapApiToProps` is a function.  This enables the creation of dynamic filters and groups based on the
    // arguments passed to the @connect-ed Component.
    if (mapApiToProps instanceof Function) {
      mapApiToPropsMap = mapApiToProps(state, ownProps);
    }

    var subscriptions = []; // Initialize subscription tracking

    // Walk all the data sources to determine the new dependency graph for data sources

    var _connectExtractDepend = connectExtractDependencies(mapApiToPropsMap, ownProps),
        propOrder = _connectExtractDepend.propOrder,
        definitions = _connectExtractDepend.definitions,
        dependencies = _connectExtractDepend.dependencies;

    // Process the graph in toplogical sort order


    var metaStorage = {};
    var finalDefinitions = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = propOrder[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var prop = _step3.value;

        var definition = definitions[prop]; // Extract the definition for this prop

        // Check if any of the queries are functions
        var _definition = definition,
            enabled = _definition.enabled,
            subscribed = _definition.subscribed,
            dataSource = _definition.dataSource,
            group = _definition.group,
            query = _definition.query,
            sort = _definition.sort,
            limit = _definition.limit,
            only = _definition.only,
            alias = _definition.alias,
            withMeta = _definition.withMeta;

        // Run the dynamic definition (and reconcile any overwritten definition props)

        if (definition.dynamicDefinition instanceof Function) {
          var requiredProps = {};
          if (definition.requires !== undefined) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = definition.requires[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var required = _step4.value;

                requiredProps[required] = stateToProps[required];
                // Meta will just come along for the ride for all dependencies
                requiredProps[required + metaPostfix] = metaStorage[required];
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }

          var updated = connectExtractDefinition(definition.dynamicDefinition(state, ownProps, requiredProps), ownProps, { checkDataSource: false, setDefaultAlias: false });

          if (updated.enabled !== undefined) {
            enabled = updated.enabled;
          }
          if (updated.subscribed !== undefined) {
            subscribed = updated.subscribed;
          }
          if (updated.dataSource !== undefined) {
            dataSource = updated.dataSource;
          }
          if (updated.group !== undefined) {
            group = updated.group;
          }
          if (updated.query !== undefined) {
            query = updated.query;
          }
          if (updated.sort !== undefined) {
            sort = updated.sort;
          }
          if (updated.limit !== undefined) {
            limit = updated.limit;
          }
          if (updated.only !== undefined) {
            only = updated.only;
          }
          if (updated.withMeta !== undefined) {
            // Similar to connectExtract Definition with Meta behaves differently and can only be
            // upgraded to true, but not downgraded to false.
            withMeta = withMeta || updated.withMeta;
          }

          if (updated.alias !== undefined) {
            alias = updated.alias;
          } else {
            // WORKAROUND: Don't let the default alias carry through if other things are overridden.
            if (alias === _constants.DEFAULT_API_FILTER_NAME) {
              alias = undefined;
            }
            alias = (0, _constants.filterDefault)(alias, query, sort, only, limit);
          }

          // Make a new definition based on any potentially changed items.
          definition = _ConnectDefinitionRecord({
            enabled: enabled,
            subscribed: subscribed,
            dataSource: dataSource,
            requires: definition.requires,
            dynamicDefinition: definition.dynamicDefinition,
            alias: alias,
            query: query,
            sort: sort,
            only: only,
            limit: limit,
            group: group,
            withMeta: withMeta
          });
        }

        // TRICK: Set the filter sentinel if not enabled and reset the alias
        if (enabled !== undefined && !enabled) {
          query = reducer.disabledFilterSentinel;
          alias = (0, _constants.filterDefault)(undefined, reducer.disabledFilterSentinel);
        }

        // Read the payload state into the given prop
        var payload = reducer.read(state, dataSource, group, alias);
        if (limit === LIMIT_ITEM) {
          if (payload && payload.firstItem) {
            payload = payload.firstItem();
          } else {
            payload = null;
          }
        }
        stateToProps[prop] = payload;

        // Read the meta state if it's directly requested, or it's needed for dependency tracking
        var isDependency = dependencies.has(prop);
        if (isDependency || withMeta === true) {
          var metaState = reducer.meta(state, dataSource, group, alias);
          if (withMeta) {
            stateToProps[prop + metaPostfix] = metaState;
          }
          if (withMeta || isDependency) {
            metaStorage[prop] = metaState;
          }
        }

        var onAdded = void 0,
            onNotify = void 0;
        if (subscribed === undefined || subscribed) {
          onAdded = reducer.maybeRequest(dataSource, group, alias);
          onNotify = reducer.maybeRequest(dataSource, group, alias);
        } else {
          onAdded = NO_ACTION;
          onNotify = NO_ACTION;
        }

        // Setup new subscriptions.  Even disabled entries will subscribe, because it allows the
        // fetching of the model prior to a valid query being available in dependant load cases.
        var subscribeLimit = limit === LIMIT_ITEM ? 1 : limit;
        subscriptions.push({
          enabled: enabled,
          subscribed: subscribed,
          dataSource: dataSource,
          filter: (0, _constants.subscribeFilterDefault)(query),
          group: (0, _constants.groupName)(group),
          alias: alias,
          sort: sort,
          only: only,
          limit: subscribeLimit,
          onSubscribe: reducer.subscribe(dataSource, group, query, sort, subscribeLimit, only, alias),
          onAdded: onAdded,
          onNotify: onNotify,
          onUnsubscribe: reducer.unsubscribe(dataSource, group, alias)
        });

        // Create final map of props and definitions
        finalDefinitions[prop] = definition;
      }

      // Add final definitions to state temporarily so that merge props can have access
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    stateToProps[apiToPropsKey] = finalDefinitions;
    stateToProps[apiToPropsMetaKey] = metaStorage;

    // If there is a subscriber for connect, then add the subscriptions prop
    if (reducer.connectSubscriber !== undefined) {
      stateToProps[subscriptionsKey] = (0, _immutable.List)(subscriptions);
    }

    return stateToProps;
  };
}

/*
 * Generate a React-Redux connect compatible mapStateToProps function based on a set of data sources
 */
function connectMapDispatchToProps(connectDispatchKey) {
  return function _connectMapDispatchToProps(dispatch) {
    return _defineProperty({}, connectDispatchKey, dispatch);
  };
}

/*
 * Generate a React-Redux connect compatible mergeProps based on the content of the `apiToPropsKey`
 */
function connectMergeProps(reducer, apiToPropsKey, apiToPropsMetaKey, connectDispatchKey, metaPostfix) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var _options$transformPro2 = options.transformProps,
      transformProps = _options$transformPro2 === undefined ? undefined : _options$transformPro2,
      _options$bundleProp2 = options.bundleProp,
      bundleProp = _options$bundleProp2 === undefined ? undefined : _options$bundleProp2,
      _options$bundleMetaPr2 = options.bundleMetaProp,
      bundleMetaProp = _options$bundleMetaPr2 === undefined ? undefined : _options$bundleMetaPr2,
      _options$cache = options.cache,
      cache = _options$cache === undefined ? undefined : _options$cache;


  var metaBundleCacheKey = 'metaBundle';

  return function _connectMergeProps(stateProps, dispatchProps, props) {
    // Extract the dispatch and remove it.
    var dispatch = dispatchProps[connectDispatchKey];

    var definitions = stateProps[apiToPropsKey];
    var metaStorage = stateProps[apiToPropsMetaKey];

    // Cleanup the passthrough props now that we don't need them anymore
    delete stateProps[apiToPropsKey];
    delete stateProps[apiToPropsMetaKey];

    // For each prop specified in the connect, bind action creators to all the collection and item actions
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      var _loop = function _loop() {
        var _step5$value = _slicedToArray(_step5.value, 2),
            prop = _step5$value[0],
            definition = _step5$value[1];

        // Get the unbound prop (should have been provided in _connectMapStateToProps)
        var result = stateProps[prop];

        if (result !== undefined && result !== null && result.dispatch !== dispatch) {
          // Bind Result (Both Collections and Items have the same bindReducer API)
          result.bindReducer(reducer, dispatch, definition.dataSource, definition.group, definition.alias);

          if (result.isCollection) {
            // Bind all items it the collection.
            result.forEach(function (item) {
              return item.bindReducer(reducer, dispatch, definition.dataSource, definition.group, definition.alias);
            });
          } else if (result.isItem) {
            // Nothing to do for items
          } else {
            throw 'Unknown result found in connectMapDispatchToProps: ' + result;
          }
        }
      };

      for (var _iterator5 = (0, _utils.walkMap)(definitions)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        _loop();
      }

      // Let caller perform any transformations they'd like on the individual props
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    if (transformProps !== undefined) {
      stateProps = transformProps(stateProps, props, definitions, metaStorage);
    }

    // Bundle up the props (if requested)
    if (bundleProp !== undefined) {
      if (bundleMetaProp !== undefined) {
        var _extends2;

        var dataProps = {};
        var metaProps = {};
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = (0, _utils.walkMapKeys)(definitions)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var propKey = _step6.value;

            var metaPropKey = propKey + metaPostfix;
            dataProps[propKey] = stateProps[propKey];
            if (stateProps[metaPropKey]) {
              metaProps[propKey] = stateProps[metaPropKey];
            }
            delete stateProps[propKey];
            delete stateProps[metaPropKey];
          }

          // Cache dance in order to keep the latest immutable instance so that meta bundles are
          // equality comparable.
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        var metaBundle = void 0;
        //   Check cache
        if (cache !== undefined) {
          metaBundle = cache[metaBundleCacheKey];
        }
        //   Create new bundle if one doesn't exist
        if (metaBundle === undefined) {
          metaBundle = new _models.MetaCollection({ metas: (0, _immutable.Map)() });
        }
        //   Update bundle
        var newKeys = (0, _immutable.Set)((0, _utils.walkMapKeys)(metaProps));
        metaBundle = metaBundle.update('metas', function (s) {
          return s.merge(metaProps).filter(function (v, k) {
            return newKeys.has(k);
          });
        });
        //   Update cache
        if (cache !== undefined) {
          cache[metaBundleCacheKey] = metaBundle;
        }

        stateProps = _extends({}, stateProps, (_extends2 = {}, _defineProperty(_extends2, bundleProp, dataProps), _defineProperty(_extends2, bundleMetaProp, metaBundle), _extends2));
      } else {
        var allProps = {};
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = (0, _utils.walkMapKeys)(definitions)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _propKey = _step7.value;

            var _metaPropKey = _propKey + metaPostfix;
            allProps[_propKey] = stateProps[_propKey];
            allProps[_metaPropKey] = stateProps[_metaPropKey];
            delete stateProps[_propKey];
            delete stateProps[_metaPropKey];
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        stateProps = _extends({}, stateProps, _defineProperty({}, bundleProp, allProps));
      }
    }

    return _extends({}, stateProps, props);
  };
}